import { agentNotificationsCollection } from "@/config/firebase";
import * as MutationsType from "./mutationsType";

export default {
  async getAllNewNotifications({ commit, rootState, state }) {
    try {
      let agent = rootState.Agent.agent;
      let reference = agentNotificationsCollection;

      reference = reference.doc(agent.uid).collection("notifications").orderBy("created_at", "asc");

      const unsubscribe = await reference.onSnapshot(async (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            let newNotifications = [];

            snapshot.docs.forEach((doc) => {
              if (state.notifications.find((t) => t.id === doc.id)) return;

              newNotifications.push({ ...doc.data(), id: doc.id });
              //commit(MutationsType.ADD_NOTIFICATION, { ...doc.data(), id: doc.id });
            });

            commit(MutationsType.SET_NOTIFICATIONS, newNotifications);
          }

          if (change.type === "modified") {
            snapshot.docs.forEach((doc) => {
              commit(MutationsType.UPDATE_NOTIFICATION, { id: doc.id, value: doc.data() });
            });
          }

          if (change.type === "removed") {
            commit(MutationsType.REMOVE_NOTIFICATION, { id: change.doc.id });
          }
        });
      });

      commit(MutationsType.UNSUBSCRIBE_GET_ALL_NOTIFICATIONS, unsubscribe);
    } catch (error) {
      console.error("getAllNotifications: ", error);
    }
  },
  async unsubscribeGetAllNotifications({ commit, state }) {
    if (state.unsubscribeNotifications) state.unsubscribeNotifications();

    commit(MutationsType.SET_NOTIFICATIONS, null);
    commit(MutationsType.UNSUBSCRIBE_GET_ALL_NOTIFICATIONS, null);
  },
};
